import axios from "axios";

const axiosInstance = axios.create({
	baseURL: "https://instantfencequote.com/api",
	headers: {
		"Content-Type": "application/json",
	},
});

export default axiosInstance;
